import { apiClient, coreApiClient } from '../../services/api';
const memoryApi = {
  getMemory: (params = {}) => coreApiClient.get('/memory', { params }).then((r) => r.data),
  updateFace: (groupId, payload) =>
    coreApiClient.put(`/memory/faces/${encodeURIComponent(groupId)}`, payload).then((r) => r.data),
  updateFaces: (faces) =>
    coreApiClient.put('/memory/faces', { faces }).then((r) => r.data),
  deleteFace: (groupId) =>
    coreApiClient.delete(`/memory/faces/${encodeURIComponent(groupId)}`).then((r) => r.data),
  deleteAllFaces: () =>
    coreApiClient.delete('/memory/faces').then((r) => r.data),
  rebuildFaceStats: () =>
    coreApiClient.post('/memory/face-stats/rebuild').then((r) => r.data),
  refreshFaceThumbnail: (groupId) =>
    coreApiClient.post(`/memory/faces/${encodeURIComponent(groupId)}/thumbnail/refresh`).then((r) => r.data),
  getFaceThumbnailUrls: (keys) =>
    apiClient.post('/memory/face-thumbnail-urls', { keys }).then((r) => r.data),
  updateGeneralNotes: (notes) =>
    coreApiClient.put('/memory/general-notes', { notes }).then((r) => r.data),
};

export default memoryApi;
